import { FC } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import "./assets/css/styles.scss";
import { BrowserRouter as Router } from "react-router-dom";
import SearchForm from "./components/searchForm/searchForm";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <SearchForm />
      </Router>
    </QueryClientProvider>
  );
};

export default App;
